<template>
  <footer class="site-footer">
    <div class="site-footer__inner">
      <div class="footer-brand">
        <img src="../assets/logo-afm.gif" alt="AfM" />
        <div>
          <strong>Arbeitskreis für Mammillarienfreunde e.V.</strong>
          <p v-if="sprachID === 0">Gemeinsam für Wissen, Austausch und die Faszination Mammillaria.</p>
          <p v-else>Knowledge, exchange and a shared passion for Mammillaria.</p>
        </div>
      </div>

      <div class="footer-contact">
        <a href="tel:0352084765"><svg class="icon-svg footer-icon-svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M7.2 3.5 10 7.8 8.2 9.6c1.1 2.5 3.2 4.6 5.7 5.7l1.8-1.8 4.3 2.8-.8 3.2c-.2.8-1 1.4-1.8 1.3C9.7 20 4 14.3 3.2 6.6c-.1-.8.5-1.6 1.3-1.8l2.7-.7Z"/></svg><span>035208-4765</span></a>
        <a href="mailto:afm-geschaeftsstelle@mammillaria.eu"><svg class="icon-svg footer-icon-svg" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="5" width="17" height="14" rx="2"/><path d="m4.5 7 7.5 6 7.5-6"/></svg><span>afm-geschaeftsstelle@mammillaria.eu</span></a>
      </div>

      <nav class="footer-nav" aria-label="Rechtliches">
        <router-link to="/Datenschutz">Datenschutz</router-link>
        <router-link to="/Impressum">Impressum</router-link>
      </nav>
    </div>
    <div class="site-footer__bottom">© {{ new Date().getFullYear() }} AfM</div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter",
  computed: {
    sprachID() {
      return this.$store.getters.getSprachID;
    },
  },
};
</script>
